// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/plugin.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { PageRequest, PageResponse } from "./common_pb.js";

/**
 * @generated from enum omnios.v1.CapabilityLevel
 */
export const CapabilityLevel = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.CapabilityLevel",
  [
    {no: 0, name: "CAPABILITY_LEVEL_UNSPECIFIED"},
    {no: 1, name: "READ"},
    {no: 2, name: "WRITE"},
    {no: 3, name: "ADMIN"},
    {no: 4, name: "EXTERNAL"},
  ],
);

/**
 * @generated from enum omnios.v1.PluginSourceType
 */
export const PluginSourceType = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.PluginSourceType",
  [
    {no: 0, name: "PLUGIN_SOURCE_TYPE_UNSPECIFIED"},
    {no: 1, name: "REGISTRY"},
    {no: 2, name: "GITHUB"},
    {no: 3, name: "EMBEDDED"},
  ],
);

/**
 * @generated from message omnios.v1.Plugin
 */
export const Plugin = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Plugin",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "author", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "category", kind: "message", T: PluginCategory },
    { no: 9, name: "source_type", kind: "enum", T: proto3.getEnumType(PluginSourceType) },
    { no: 10, name: "source_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "downloads", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "rating", kind: "message", T: RatingStats },
    { no: 13, name: "capabilities", kind: "message", T: Capability, repeated: true },
    { no: 14, name: "featured", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "homepage_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "repository_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "readme", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "changelog", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 21, name: "created_at", kind: "message", T: Timestamp },
    { no: 22, name: "updated_at", kind: "message", T: Timestamp },
    { no: 23, name: "developer", kind: "message", T: PluginDeveloper },
    { no: 24, name: "feature_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.InstalledPlugin
 */
export const InstalledPlugin = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.InstalledPlugin",
  () => [
    { no: 1, name: "plugin", kind: "message", T: Plugin },
    { no: 2, name: "installed_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "config", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 5, name: "approved_capabilities", kind: "message", T: Capability, repeated: true },
    { no: 6, name: "pending_capabilities", kind: "message", T: Capability, repeated: true },
    { no: 7, name: "installed_at", kind: "message", T: Timestamp },
    { no: 8, name: "installed_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.PluginCategory
 */
export const PluginCategory = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PluginCategory",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "plugin_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.PluginDeveloper
 */
export const PluginDeveloper = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PluginDeveloper",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "website", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "github_username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "bio", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.Capability
 */
export const Capability = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Capability",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "level", kind: "enum", T: proto3.getEnumType(CapabilityLevel) },
  ],
);

/**
 * @generated from message omnios.v1.RatingStats
 */
export const RatingStats = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RatingStats",
  () => [
    { no: 1, name: "avg_rating", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "review_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "five_star", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "four_star", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "three_star", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "two_star", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "one_star", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.PluginReview
 */
export const PluginReview = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PluginReview",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reviewer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "reviewer_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "reviewer_avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "rating", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "helpful_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.PluginVersion
 */
export const PluginVersion = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PluginVersion",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "changelog", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "published_at", kind: "message", T: Timestamp },
    { no: 4, name: "yanked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "yanked_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPluginsRequest
 */
export const ListPluginsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPluginsRequest",
  () => [
    { no: 1, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "source_type", kind: "enum", T: proto3.getEnumType(PluginSourceType) },
    { no: 3, name: "sort_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListPluginsResponse
 */
export const ListPluginsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPluginsResponse",
  () => [
    { no: 1, name: "plugins", kind: "message", T: Plugin, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.GetPluginRequest
 */
export const GetPluginRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPluginRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetPluginResponse
 */
export const GetPluginResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPluginResponse",
  () => [
    { no: 1, name: "plugin", kind: "message", T: Plugin },
    { no: 2, name: "versions", kind: "message", T: PluginVersion, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SearchPluginsRequest
 */
export const SearchPluginsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchPluginsRequest",
  () => [
    { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sort_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.SearchPluginsResponse
 */
export const SearchPluginsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchPluginsResponse",
  () => [
    { no: 1, name: "plugins", kind: "message", T: Plugin, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.ListPluginCategoriesRequest
 */
export const ListPluginCategoriesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPluginCategoriesRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListPluginCategoriesResponse
 */
export const ListPluginCategoriesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPluginCategoriesResponse",
  () => [
    { no: 1, name: "categories", kind: "message", T: PluginCategory, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetFeaturedPluginsRequest
 */
export const GetFeaturedPluginsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetFeaturedPluginsRequest",
  () => [
    { no: 1, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetFeaturedPluginsResponse
 */
export const GetFeaturedPluginsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetFeaturedPluginsResponse",
  () => [
    { no: 1, name: "plugins", kind: "message", T: Plugin, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.InstallPluginRequest
 */
export const InstallPluginRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.InstallPluginRequest",
  () => [
    { no: 1, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "config", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * @generated from message omnios.v1.InstallPluginResponse
 */
export const InstallPluginResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.InstallPluginResponse",
  () => [
    { no: 1, name: "installed", kind: "message", T: InstalledPlugin },
    { no: 2, name: "pending_approval", kind: "message", T: Capability, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.UninstallPluginRequest
 */
export const UninstallPluginRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UninstallPluginRequest",
  () => [
    { no: 1, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UninstallPluginResponse
 */
export const UninstallPluginResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UninstallPluginResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ListInstalledPluginsRequest
 */
export const ListInstalledPluginsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListInstalledPluginsRequest",
  () => [
    { no: 1, name: "enabled_only", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ListInstalledPluginsResponse
 */
export const ListInstalledPluginsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListInstalledPluginsResponse",
  () => [
    { no: 1, name: "plugins", kind: "message", T: InstalledPlugin, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetInstalledPluginRequest
 */
export const GetInstalledPluginRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetInstalledPluginRequest",
  () => [
    { no: 1, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetInstalledPluginResponse
 */
export const GetInstalledPluginResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetInstalledPluginResponse",
  () => [
    { no: 1, name: "plugin", kind: "message", T: InstalledPlugin },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePluginConfigRequest
 */
export const UpdatePluginConfigRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePluginConfigRequest",
  () => [
    { no: 1, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "config", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePluginConfigResponse
 */
export const UpdatePluginConfigResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePluginConfigResponse",
  () => [
    { no: 1, name: "plugin", kind: "message", T: InstalledPlugin },
  ],
);

/**
 * @generated from message omnios.v1.EnablePluginRequest
 */
export const EnablePluginRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EnablePluginRequest",
  () => [
    { no: 1, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.EnablePluginResponse
 */
export const EnablePluginResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EnablePluginResponse",
  () => [
    { no: 1, name: "plugin", kind: "message", T: InstalledPlugin },
  ],
);

/**
 * @generated from message omnios.v1.DisablePluginRequest
 */
export const DisablePluginRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DisablePluginRequest",
  () => [
    { no: 1, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DisablePluginResponse
 */
export const DisablePluginResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DisablePluginResponse",
  () => [
    { no: 1, name: "plugin", kind: "message", T: InstalledPlugin },
  ],
);

/**
 * @generated from message omnios.v1.ApproveCapabilitiesRequest
 */
export const ApproveCapabilitiesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ApproveCapabilitiesRequest",
  () => [
    { no: 1, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "capability_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ApproveCapabilitiesResponse
 */
export const ApproveCapabilitiesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ApproveCapabilitiesResponse",
  () => [
    { no: 1, name: "plugin", kind: "message", T: InstalledPlugin },
  ],
);

/**
 * @generated from message omnios.v1.GetPendingCapabilitiesRequest
 */
export const GetPendingCapabilitiesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPendingCapabilitiesRequest",
  () => [
    { no: 1, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetPendingCapabilitiesResponse
 */
export const GetPendingCapabilitiesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPendingCapabilitiesResponse",
  () => [
    { no: 1, name: "capabilities", kind: "message", T: Capability, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ListReviewsRequest
 */
export const ListReviewsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListReviewsRequest",
  () => [
    { no: 1, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sort_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListReviewsResponse
 */
export const ListReviewsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListReviewsResponse",
  () => [
    { no: 1, name: "reviews", kind: "message", T: PluginReview, repeated: true },
    { no: 2, name: "stats", kind: "message", T: RatingStats },
    { no: 3, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.CreateReviewRequest
 */
export const CreateReviewRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateReviewRequest",
  () => [
    { no: 1, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rating", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateReviewResponse
 */
export const CreateReviewResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateReviewResponse",
  () => [
    { no: 1, name: "review", kind: "message", T: PluginReview },
  ],
);

/**
 * @generated from message omnios.v1.UpdateReviewRequest
 */
export const UpdateReviewRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateReviewRequest",
  () => [
    { no: 1, name: "review_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rating", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateReviewResponse
 */
export const UpdateReviewResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateReviewResponse",
  () => [
    { no: 1, name: "review", kind: "message", T: PluginReview },
  ],
);

/**
 * @generated from message omnios.v1.DeleteReviewRequest
 */
export const DeleteReviewRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteReviewRequest",
  () => [
    { no: 1, name: "review_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteReviewResponse
 */
export const DeleteReviewResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteReviewResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.RegisterDeveloperRequest
 */
export const RegisterDeveloperRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RegisterDeveloperRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "website", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "github_username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "bio", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RegisterDeveloperResponse
 */
export const RegisterDeveloperResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RegisterDeveloperResponse",
  () => [
    { no: 1, name: "developer", kind: "message", T: PluginDeveloper },
  ],
);

/**
 * @generated from message omnios.v1.PublishPluginRequest
 */
export const PublishPluginRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PublishPluginRequest",
  () => [
    { no: 1, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "category_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "homepage_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "repository_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "readme", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "changelog", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "wasm_bytes", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 12, name: "manifest_toml", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.PublishPluginResponse
 */
export const PublishPluginResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PublishPluginResponse",
  () => [
    { no: 1, name: "plugin", kind: "message", T: Plugin },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePluginMetadataRequest
 */
export const UpdatePluginMetadataRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePluginMetadataRequest",
  () => [
    { no: 1, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "homepage_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "repository_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "readme", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePluginMetadataResponse
 */
export const UpdatePluginMetadataResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePluginMetadataResponse",
  () => [
    { no: 1, name: "plugin", kind: "message", T: Plugin },
  ],
);

/**
 * @generated from message omnios.v1.GetDeveloperPluginsRequest
 */
export const GetDeveloperPluginsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetDeveloperPluginsRequest",
  [],
);

/**
 * @generated from message omnios.v1.GetDeveloperPluginsResponse
 */
export const GetDeveloperPluginsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetDeveloperPluginsResponse",
  () => [
    { no: 1, name: "plugins", kind: "message", T: Plugin, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetPluginAnalyticsRequest
 */
export const GetPluginAnalyticsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPluginAnalyticsRequest",
  () => [
    { no: 1, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "period", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetPluginAnalyticsResponse
 */
export const GetPluginAnalyticsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPluginAnalyticsResponse",
  () => [
    { no: 1, name: "total_downloads", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "active_installations", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "avg_rating", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "review_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "downloads_over_time", kind: "message", T: AnalyticsDataPoint, repeated: true },
    { no: 6, name: "installations_over_time", kind: "message", T: AnalyticsDataPoint, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.AnalyticsDataPoint
 */
export const AnalyticsDataPoint = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AnalyticsDataPoint",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "value", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

